// extracted by mini-css-extract-plugin
module.exports = {"item":"UserBoard_item__37cEp","addUserForm":"UserBoard_addUserForm__3Lc7h","formBtnGroup":"UserBoard_formBtnGroup__3pHvk"};